import React, { useState } from 'react'
import './style.css'
import EngagementModelTable from '../engagement-models-table/EngagementModelTable';
import SubscriptionCard from '../SubscriptionCard/SubscriptionCard';

const SubscriptionPlans = () => {

    const [activeTab, setActiveTab] = useState("tab1");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    const monthlySubscriptionPlans = [
        {
            package: "Growth",
            priceBefore: "$300",
            priceNow: "$300 / monthly",
            hoursIncluded: "25 hr",
            rolesIncluded: "1 Developer",
            features: ["Bulk product uploads", "Inventory & pricing cycles", "Image optimization + banners", "SEO descriptions"],
            perfectFor: "Shopify, Amazon, eBay, Etsy, Walmart",
            subscribeLink: "https://buy.stripe.com/cNi28r8W10ZG64P4h39Zm0i",
            // upgradeLink: "https://buy.stripe.com/bJeaEX3BHgYEfFpeVH9Zm02", // link to upgrade page or contact form
            upgradable: true,
        },
        {
            package: "Pro",
            priceBefore: "$550",
            priceNow: "$550 / monthly",
            hoursIncluded: "50 hr",
            rolesIncluded: "1 Developer",
            features: ["Unlimited product uploads", "Weekly inventory/price sync", "Advanced SEO optimization", "Store performance reporting", "Dedicated VA assigned"],
            perfectFor: "Shopify, Amazon, eBay, Etsy, Walmart, WooCommerce",
            subscribeLink: "https://buy.stripe.com/fZu6oHeglcIo9h128V9Zm0j",
            // upgradeLink: "https://buy.stripe.com/28EfZha05aAg9h1aFr9Zm04",
            upgradable: true,
        },
        {
            package: "Enterprise",
            priceBefore: "$1000",
            priceNow: "$1000 / monthly",
            hoursIncluded: "100+ hr",
            rolesIncluded: "1 Developer + 1 Dedicated PM",
            features: ["Dedicated full-time VA/Developer", "Advanced analytics/reporting", "API integrations & automation", "Multi-channel management", "Private Slack channel"],
            perfectFor: "Shopify Plus, Amazon, eBay, Etsy, Walmart, WooCommerce, Magento, BigCommerce",
            subscribeLink: "https://buy.stripe.com/6oUbJ10pv23K9h19Bn9Zm0k",
            upgradeLink: "#",
            upgradable: false,
        },
    ];

    const annualSubscriptionPlans = [
        {
            package: "Growth",
            priceBefore: "$675",
            priceNow: "$675 / quarterly",
            hoursIncluded: "25 hr",
            rolesIncluded: "1 Developer",
            features: ["Bulk product uploads", "Inventory & pricing cycles", "Image optimization + banners", "SEO descriptions"],
            perfectFor: "Shopify, Amazon, eBay, Etsy, Walmart",
            subscribeLink: "https://buy.stripe.com/cNi28r1tz6k0bp9bJv9Zm0l",
            // upgradeLink: "https://buy.stripe.com/dRm3cv0pv37OgJt28V9Zm07",
            upgradable: true,
        },
        {
            package: "Pro",
            priceBefore: "$1239",
            priceNow: "$1239 / quarterly",
            hoursIncluded: "50 hr",
            rolesIncluded: "1 Developer",
            features: ["Unlimited product uploads", "Weekly inventory/price sync", "Advanced SEO optimization", "Store performance reporting", "Dedicated VA assigned"],
            perfectFor: "Shopify, Amazon, eBay, Etsy, Walmart, WooCommerce",
            subscribeLink: "https://buy.stripe.com/cNi3cveglgYE3WH5l79Zm0m",
            // upgradeLink: "https://buy.stripe.com/7sY3cv4FL9wceBlbJv9Zm09",
            upgradable: true,
        },
        {
            package: "Enterprise",
            priceBefore: "$2250",
            priceNow: "$2250 / quartrly",
            hoursIncluded: "100+ hr",
            rolesIncluded: "1 Developer + 1 Dedicated PM",
            features: ["Dedicated full-time VA/Developer", "Advanced analytics/reporting", "API integrations & automation", "Multi-channel management", "Private Slack channel"],
            perfectFor: "Shopify Plus, Amazon, eBay, Etsy, Walmart, WooCommerce, Magento, BigCommerce",
            subscribeLink: "https://buy.stripe.com/9B6eVddch8s8eBl14R9Zm0n",
            upgradeLink: "#",
            upgradable: false,
        },
    ];

    return (
        <>
            <div className="packages-subscription-main-box">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-md-12">
                            <h3 class="packages-heading-text">Empower Your <span>Ecommerce Brand</span> With Elite Management & Growth Support</h3>
                            <p className="description-text-white text-center">Select the perfect subscription plan to match your project's scale, from small startups to large enterprises, & instantly access a dedicated developer & project management resources.</p>
                            {/* <h5 className='save-offer-price'>Save 20%</h5> */}
                            <h2 className='black-friday-text'>Black Friday Sale!</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {/* <div className="packages-tabs-header">
                                <button
                                    className={`tab-button ${activeTab === "tab1" ? "active-packages-tab" : ""}`}
                                    onClick={() => handleTabClick("tab1")}
                                >
                                    Monthly
                                </button>
                                <button
                                    className={`tab-button ${activeTab === "tab2" ? "active-packages-tab" : ""}`}
                                    onClick={() => handleTabClick("tab2")}
                                >
                                    Yearly <span className='yearly-subscription-discount'>(Save 20%)</span>
                                </button>
                            </div> */}

                            <div className="subscription-toggle">
                                <span className={`toggle-label ${activeTab === "tab1" ? "active" : ""}`}>
                                    Monthly
                                </span>

                                <div
                                    className={`toggle-switch ${activeTab === "tab2" ? "active" : ""}`}
                                    onClick={() =>
                                        handleTabClick(activeTab === "tab1" ? "tab2" : "tab1")
                                    }
                                >
                                    <div className="toggle-circle"></div>
                                </div>

                                <span className={`toggle-label ${activeTab === "tab2" ? "active" : ""}`}>
                                    Quarterly / <strong>3 Months</strong> <span className="save-text">(Save 25%)</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tab Content */}
                <div className="tabs-content">
                    {activeTab === "tab1" && <div className="tab-panel">
                        <div className="container">
                            <div className="row">
                                {monthlySubscriptionPlans.map((plan, index) => (
                                    <SubscriptionCard key={index} plan={plan} />
                                ))}
                            </div>
                        </div>
                    </div>}
                    {activeTab === "tab2" && <div className="tab-panel">
                        <div className="container">
                            <div className="row">
                                {annualSubscriptionPlans.map((plan, index) => (
                                    <SubscriptionCard key={index} plan={plan} />
                                ))}
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    )
}

export default SubscriptionPlans